import {
  SET_ADDITIONAL_CHARGES_EXIT_USERIDS,
} from './mutation-types'
const state = {
  exitUserIds: [],
}

const mutations = {
  [SET_ADDITIONAL_CHARGES_EXIT_USERIDS](state, payload = []) {
    state.exitUserIds = payload
  },
}

export default {
  namespaced: true,
  state,
  mutations,
}
